export class Supplier
{
    SupplierAB!: Number;
    SupplierName!: string;
    SupplierShortName!: string;
    ABAT1!: string;
    Date_Updated? : Number
}